"use client";

import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const checklistItems = ["Ofsted registered", "State of the art homes", "30+ Years Experience", "Round the clock care"];
  return <section id="about-us" className="py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className={`relative transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515527/img/child_in_care_home.png" alt="Child receiving care" className="w-full h-auto object-cover" />
              <div className="absolute top-6 left-6">
                <Badge asChild className="bg-secondary2 text-foreground-secondary2 px-4 py-3 text-sm font-semibold shadow-soft border-0">
                  
                </Badge>
              </div>
            </div>
          </div>

          {}
          <div ref={contentRef} className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-accent mb-6">
              A nurturing place to grow.
            </h2>
            
            <div className="space-y-4 mb-8">
              <p className="text-foreground leading-relaxed">Thrive provides residential care for children with neurodevelopmental disorders in a stable, nurturing setting. We deliver relationship-led, trauma-informed support using the Nurtured Heart Approach® as our core model. Our aim is to improve placement stability, reduce escalation, and support children’s progress through consistent routines, strengths-based practice, and coordinated multi-agency working.</p>
              <p className="text-foreground leading-relaxed">
                We believe in person-centered care that respects individual choices, promotes independence, and fosters meaningful community connections. Our modern homes are designed to provide comfort, accessibility, and a true sense of belonging.
              </p>
            </div>

            <ul className="space-y-4">
              {checklistItems.map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-foreground">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary flex items-center justify-center">
                    <Check className="w-4 h-4 text-foreground-secondary stroke-[3px]" />
                  </div>
                  <span className="text-base font-medium">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}